const cloneDate = (date: Date): Date => new Date(date.getTime());

export const addDays = (date: Date, days: number) =>  new Date(cloneDate(date).setDate(date.getDate() + days));
export const addMonths = (date: Date, months: number) =>  new Date(cloneDate(date).setMonth(date.getMonth() + months));
export const addYears = (date: Date, years: number) =>  new Date(cloneDate(date).setFullYear(date.getFullYear() + years));